import { render, staticRenderFns } from "./AnimatorSidebar.vue?vue&type=template&id=5b431b46&scoped=true&"
import script from "./AnimatorSidebar.vue?vue&type=script&lang=js&"
export * from "./AnimatorSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b431b46",
  null
  
)

export default component.exports